import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Birthday"),
    /*#__PURE__*/_createElementVNode("th", null, "Age"),
    /*#__PURE__*/_createElementVNode("th", null, "HRN")
  ])
], -1)
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  colspan: "5",
  class: "text-center pa-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_row, { justify: "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            variant: "flat",
            class: "mx-auto mt-15"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Patient Search")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "solo",
                    label: "Search Patient by Name, HRN, Address, Phone#",
                    "append-inner-icon": _ctx.loading ? undefined : 'mdi-magnify',
                    "single-line": "",
                    hint: "Search by Name, HRN, Address, Phone#",
                    "onClick:appendInner": _ctx.onClick,
                    class: "rounded-input"
                  }, _createSlots({ _: 2 }, [
                    (_ctx.loading)
                      ? {
                          name: "append-inner",
                          fn: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: _ctx.loading,
                              color: "jamzcare"
                            }, null, 8, ["indeterminate"])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["append-inner-icon", "onClick:appendInner"])
                ]),
                _: 1
              }),
              (_ctx.loaded)
                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                    default: _withCtx(() => [
                      (_ctx.patientResult)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_table, { class: "pb-5" }, {
                                    default: _withCtx(() => [
                                      _hoisted_1,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientResult, (result, index) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: index,
                                            style: {"cursor":"pointer"},
                                            onClick: ($event: any) => (_ctx.selectPatient(result))
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("strong", null, _toDisplayString(result.name), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("strong", null, _toDisplayString(result.birthday), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("strong", null, _toDisplayString(result.age), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("strong", null, _toDisplayString(result.hrn), 1)
                                            ])
                                          ], 8, _hoisted_2))
                                        }), 128)),
                                        (_ctx.patientResult.length === 0)
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                              _createElementVNode("td", _hoisted_4, [
                                                _createVNode(_component_v_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("mdi-emoticon-sad")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createTextVNode(" We found nothing ")
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}